<div class="responsive-card gap-4">
  <div class="d-flex flex-column gap-3">
    <div i18n class="responsive-card-title">New Assets Added</div>
    <app-final-location-line class="label-sm final-location-line" [finalLocationId]="finalLocationId" />
  </div>

  <ng-container *ngFor="let jurisdiction of cards; trackBy: trackByJurisdictionId">
    <div class="inner-card">
      <div class="jurisdiction-grid">
        <app-final-location-jurisdiction-title
          class="jurisdiction-title"
          [jurisdictionId]="jurisdiction.jurisdictionId"
          [finalLocationId]="finalLocationId" />

        <div class="balance-sections">
          <div *ngIf="jurisdiction.showLockedSection" class="balance-section">
            <div class="d-flex flex-column gap-2">
              <div class="d-flex align-items-center gap-1">
                <span class="paragraph-lg" i18n>Locked-In</span>
                <img
                  *ngIf="jurisdiction.hasUnlock"
                  src="assets/icons/light-grey/Lock%20Off.svg"
                  alt="lock icon"
                  i18n-alt />
              </div>
              <span *ngIf="jurisdiction.useEntireLockedBalance" class="sub-label" i18n>Entire balance used*</span>
            </div>
            <div class="d-flex align-items-baseline gap-2">
              <span *ngIf="jurisdiction.showLockedStrikethrough" class="currency-amount">
                <span class="text-decoration-line-through">{{ jurisdiction.lockedBalance | currency }}</span
                ><span *ngIf="jurisdiction.showUnusedUnlockAsterisk">{{ unlockedFundsMarker }}</span>
              </span>
              <span class="label-sm">{{ jurisdiction.effectiveLockedBalance | currency }}</span>
            </div>
          </div>

          <hr
            *ngIf="jurisdiction.showLockedSection && jurisdiction.showUnlockedSection"
            class="balance-section-divider" />

          <div *ngIf="jurisdiction.showUnlockedSection" class="balance-section">
            <div class="d-flex flex-column gap-2">
              <span class="paragraph-lg" i18n>Non-Locked-In</span>
              <span *ngIf="jurisdiction.useEntireUnlockedBalance" class="sub-label" i18n>Entire balance used*</span>
            </div>
            <div class="d-flex align-items-baseline gap-2">
              <span *ngIf="jurisdiction.showUnlockedStrikethrough" class="currency-amount text-decoration-line-through">
                {{ jurisdiction.unlockedBalance | currency }}
              </span>
              <span class="label-sm">{{ jurisdiction.effectiveUnlockedBalance | currency }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="d-flex flex-column gap-2">
    <div class="new-assets-total d-flex justify-content-between align-items-center">
      <span i18n>Total of New Assets:</span>
      <span>{{ total | currency }}</span>
    </div>

    <div class="combined-balance d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center gap-2">
        <span i18n>Est. Combined Variable Benefit Balance</span>
        <img
          class="account-details-card-tooltip-img"
          [ngbTooltip]="fundAllocationTooltip"
          [triggers]="'hover focus click'"
          [src]="'assets/icons/grey/CircleQuestion.svg'"
          alt="" />
      </div>
      <span>{{ combinedBalance | currency }}</span>
    </div>
  </div>

  <div *ngIf="showDisclaimers" class="disclaimers">
    <div *ngIf="showEntireBalanceDisclaimer" i18n class="info">
      *Amount reflects full balance as of submission date. Final amount may vary based on effective date.
    </div>
    <div *ngIf="showUnlockedFundsDisclaimer" class="info">
      <span>{{ unlockedFundsMarker }}</span>
      <span>{{ unlockedFundsDisclaimer$ | async }}</span>
    </div>
  </div>
</div>

<ng-template i18n #fundAllocationTooltip>
  This includes the existing balance from all variable benefit accounts, plus new assets added.
</ng-template>
